<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="box_img_brand_project">
      <img
        src="@/assets/project/Logistics/Logistics.png"
        class="img_brand_project"
        alt="Logistics"
      />
      <img
        src="@/assets/project/Logistics/Logistics_v2.png"
        class="img_brand_project_v2"
        alt="Logistics"
      />
    </div>
    <div class="waves_full_pages"></div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4"
          >Логистическая <br />
          компания</span
        >
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button class="button_v1" data-action="toggleBig">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section_main_info_project">
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="font_2_4_700_Kreadon">2024</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="font_2_4_700_Kreadon">
          Торговый дом «Шкуренко» <br />
          Логистический комплекс
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">
          UX/UI дизайн <BR />
          &nbsp;
          <BR />
          Frontend <BR />
          &nbsp;
          <BR />
          Backend <BR />
          &nbsp;
          <BR />
          DevOps и интеграция с 1С
        </p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Крупная логистическая компания с более чем 7000 сотрудниками
        </p>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <button class="button_light">Сайт</button>
      </div>
    </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Цели</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Создать удобный и функциональный корпоративный портал для
          автоматизации работы сотрудников и эффективного управления
          логистическими процессами. Основной фокус был сделан на:
          <BR />
          &nbsp;
          <BR />
          Централизованное управление расписанием транспорта и графиками
          сотрудников
          <BR />
          &nbsp;
          <BR />
          Контроль заработной платы с полной интеграцией с 1С
          <BR />
          &nbsp;
          <BR />
          Упрощённую авторизацию сотрудников по персональному коду или
          штрих-коду
          <BR />
          &nbsp;
          <BR />
          Аналитику и показатели сотрудников в единой системе
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Задачи</p>
      </div>
      <div class="box_main_info_project_right">
        <ul class="list_articles subtext_services_design">
          <li>
            Разработать удобный личный кабинет сотрудников с отображением их
            рабочих графиков, показателей эффективности и отпускных дней
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Автоматизировать процесс управления логистикой, включая контроль
            движения транспорта и распределение рабочих смен
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Интегрировать портал с 1С, чтобы данные о зарплатах, отпусках и
            выработке автоматически обновлялись
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Обеспечить удобную авторизацию сотрудников по уникальному коду или
            штрих-коду
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Реализовать систему аналитики и отчетности, позволяющую HR-отделу и
            менеджерам контролировать эффективность работы сотрудников
          </li>
        </ul>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Решение</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">01</p>
          <p class="subtext_services_design">
            Дизайнер создавал удобный и минималистичный интерфейс, который легко
            адаптируется под любое устройство. Основной акцент сделан на
            быстроту работы и удобство навигации, чтобы минимизировать время
            сотрудников на выполнение рутинных задач.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">02</p>
          <p class="subtext_services_design">
            Благодаря современным технологиям и продуманной архитектуре системы
            удалось достичь высокой скорости работы и надежности.
          </p>
        </div>
      </div>
    </div>
    <div class="container_slaider_project">
      <button class="custom-prev">
        <img
          class="arrow_left_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>

      <button class="custom-next">
        <img
          class="arrow_right_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        loop="true"
        class="mySwiper"
        :navigation="{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="slide" class="slide-content" alt="Слайд проекта" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">03</p>
          <p class="subtext_services_design">
            Портал синхронизирован с 1С, что позволяет HR-отделу и бухгалтерии
            автоматически загружать данные о заработной плате, графике работы,
            отпусках и премиях сотрудников. Это исключает ошибки при расчётах и
            делает управление кадрами более эффективным.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">04</p>
          <p class="subtext_services_design">
            В системе реализован функционал:
          </p>
        </div>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Планирование рабочих смен с возможностью корректировки
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Автоматическое обновление графиков
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Контроль передвижения транспорта и распределение маршрутов
          </p>
        </div>
      </div>
    </div>
    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      loop="true"
      class="mySwiper_2"
    >
      <swiper-slide v-for="(slides_2, index) in slides_2" :key="index">
        <img :src="slides_2" class="simg_project" alt="Слайд проекта" />
      </swiper-slide>
    </swiper>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Результат</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            7000 сотрудников получили удобный инструмент для управления своим
            рабочим временем
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Оптимизировано расписание транспорта, что позволило сократить
            временные затраты на логистику
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Автоматизирована работа HR-отдела, исключены ошибки при расчёте
            зарплат и отпусков
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Сокращено время на административные процессы благодаря
            централизованному хранению данных
          </p>
        </div>
      </div>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Команда</p>
      </div>
      <div class="box_main_info_project_right_row">
        <ul class="ul_team subtext_services_design">
          <span class="color_violet">Команда</span>
          <li>Backend-разработка: Метелёв Илья, Ражев Дмитрий</li>
          <li>Frontend-разработка: Немчицкий Кирилл</li>
          <li>UX/UI дизайн: Стрельцова Валерия</li>
          <li>DevOps: Кошелев Ростислав</li>
        </ul>
      </div>
    </div>
  </section>
  <SectionBlog />
  <SectionProjects />
  <FooterPages />
</template>
<script>
import { useHead } from "@vueuse/head";
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionBlog from "../ui/SectionBlog.vue";
import SectionProjects from "../ui/SectionProjects.vue";

import slide_1 from "@/assets/project/Logistics/Logistics_slide_1.webp";
import slide_2 from "@/assets/project/Logistics/Logistics_slide_2.webp";
import slide_3 from "@/assets/project/Logistics/Logistics_slide_3.webp";
import slide_4 from "@/assets/project/Logistics/Logistics_slide_4.webp";
import slide_5 from "@/assets/project/Logistics/Logistics_slide_5.webp";

import slide_1_m from "@/assets/project/Logistics/Logistics_slide_1_m.webp";
import slide_2_m from "@/assets/project/Logistics/Logistics_slide_2_m.webp";
import slide_3_m from "@/assets/project/Logistics/Logistics_slide_3_m.webp";
import slide_4_m from "@/assets/project/Logistics/Logistics_slide_4_m.webp";
import slide_5_m from "@/assets/project/Logistics/Logistics_slide_5_m.webp";

export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderPages,
    FooterPages,
    SectionBlog,
    SectionProjects,
  },

  setup() {
    useHead({
      title:
        "Корпоративный портал для логистики – автоматизация, 1С, управление персоналом",
      meta: [
        {
          name: "description",
          content:
            "Разработка корпоративного портала для логистической компании. Интеграция с 1С, управление графиками сотрудников, учет зарплат, автоматизация логистики и аналитика. Улучшение бизнес-процессов.",
        },
      ],
    });
    const slides = [slide_1, slide_2, slide_3, slide_4, slide_5];
    const slides_2 = [slide_1_m, slide_2_m, slide_3_m, slide_4_m, slide_5_m];

    const slidesPerView = ref(3);

    const updateSlidesPerView = () => {
      if (window.innerWidth <= 767) {
        slidesPerView.value = 2;
      } else {
        slidesPerView.value = 3;
      }
    };
    onMounted(() => {
      updateSlidesPerView();
      window.addEventListener("resize", updateSlidesPerView);
    });
    return {
      slides,
      slides_2,
      updateSlidesPerView,
      slidesPerView,
      modules: [Navigation],
    };
  },
};
</script>
<style scoped>
.container_main_info_project {
  height: fit-content;
}
.section_main_info_project {
  gap: 2.5rem;
}

.section_header_full_pages {
  overflow: hidden;
  background: linear-gradient(
    156.64deg,
    rgb(230, 136, 85) 2.562%,
    rgb(255, 235, 254) 79.96%
  );
}
.img_brand_project {
  width: 21.45rem;
  height: 21.45rem;
}
.img_brand_project_v2 {
  display: none;
}
.box_img_brand_project {
  position: absolute;
  right: 4.3rem;
  top: 5rem;
}
.simg_project {
  height: 37rem;
  border-radius: 1.7rem;
  box-shadow: 0.7rem 0.7rem 2rem -0.8rem rgba(71, 86, 163, 0.4);
  background: rgb(245, 247, 255);
}
.fatty_font {
  font-family: Kreadon-Bold !important;
}
.mySwiper_2 {
  padding-bottom: 4rem;
}
@media (max-width: 767px) {
  .container_text_full_pages {
    padding: 11rem 2rem 4.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .section_header_full_pages {
    height: 51.36rem;
  }
  .title_home {
    z-index: 0;
  }
  .img_brand_project {
    display: none;
  }
  .img_brand_project_v2 {
    display: block;

    height: 34.64rem;
  }
  .box_img_brand_project {
    position: absolute;
    right: 0rem;
    top: 8rem;
  }
  .simg_project {
    height: 28rem;
    box-shadow: 1.27rem 1.27rem 3.64rem -1.45rem rgba(71, 86, 163, 0.4);
  }
  .mySwiper_2 {
    padding-left: 1.5rem;
    padding-bottom: 4rem;
  }
  .container_main_info_project {
    flex-direction: column;
  }
  .ul_team .color_violet {
    display: none;
  }
  .font_1_400_Kreadon_Regular {
    line-height: 1.27rem;
  }
  .container_slaider_project {
    margin: 0rem;
  }
}
</style>
